import {
  Box,
  Button,
  Center,
  Divider,
  Flex,
  Grid,
  GridItem,
  HStack,
  Link,
  Text,
  useBreakpointValue
} from "@chakra-ui/react";
import { useLocation, useNavigate } from "react-router-dom";
import Footer from "../../components/common/Footer";
import Header from "../../components/common/Header";
import HelpdeskSideNav from "../../components/common/helpdeskSidenav";
import img_location from "../../img/locationVector.svg";
import mail from "../../img/mailVector.svg";
import phone from "../../img/phoneVector.svg";
import routes from "../routes";

const HomeHelpdesk = () => {
  const navigate = useNavigate();
  const showSideNav = useBreakpointValue({ base: false, lg: true });

  const location = useLocation();

  const activeLink = (link: string) => {
    const style = {
      borderColor: "white",
      borderLeft: "",
      bgColor: "white",
      textColor: "#9E9E9E",
    };

    if (link === location.pathname) {
      style.borderColor = "#EC3337";
      style.borderLeft = "3px Solid";
      style.bgColor = "#FFFAFA";
      style.textColor = " #EC3337";
    }

    return style;
  };

  return (
    <>
      <Header />
      <Center
        bgColor="#3362AB"
        width="100%"
        textAlign="center"
        pt={["30px", "72px"]}
        height={["320px", "350px", "400px"]}
        position={"relative"}
      >
        <Text color="white" fontSize={["40px", "48px"]} fontWeight="800">
          Online Help Desk <br />& Support Centre
        </Text>
      </Center>

      {!showSideNav && (
        <HStack
          // overflowX="scroll"
          width={"100%"}
          height={"60px"}
          justifyContent={"space-around"}
          alignItems={"center"}
          fontSize={"13px"}
          padding={"0px 8px"}
        >
          <Link
            onClick={() => navigate(routes.HomeHelpdesk)}
            textAlign={"center"}
            alignContent={"center"}
            height={"60px"}
            borderBottom={activeLink(routes.HomeHelpdesk).borderLeft}
            borderColor={activeLink(routes.HomeHelpdesk).borderColor}
            color={activeLink(routes.HomeHelpdesk).textColor}
          >
            Help Desk Home{" "}
          </Link>
          <Divider orientation="vertical" height={"70%"} />
          <Link
            onClick={() => navigate(routes.HelpdeskNewRequest)}
            textAlign={"center"}
            alignContent={"center"}
            height={"60px"}
            borderBottom={activeLink(routes.HelpdeskNewRequest).borderLeft}
            borderColor={activeLink(routes.HelpdeskNewRequest).borderColor}
            color={activeLink(routes.HelpdeskNewRequest).textColor}
          >
            New Help Request
          </Link>
          <Divider orientation="vertical" height={"70%"} />
          <Link
            onClick={() => navigate(routes.PaymentGuidelines)}
            textAlign={"center"}
            alignContent={"center"}
            height={"60px"}
            borderBottom={activeLink(routes.PaymentGuidelines).borderLeft}
            borderColor={activeLink(routes.PaymentGuidelines).borderColor}
            color={activeLink(routes.PaymentGuidelines).textColor}
          >
            Payment Guideline
          </Link>
        </HStack>
      )}

      <Box bg="#F9F8F8" height="100%">
        <Flex width="90%" mx="auto" pt="80px">
          {showSideNav && <HelpdeskSideNav />}
          <Flex
            width="80%"
            minHeight="60vh"
            height="auto"
            mb="2rem"
            mx="auto"
            pb="100px"
            bg="#F9F9F9"
            justifyContent={"flex-start"}
          >
            <Grid
              templateColumns={{
                base: "repeat(1, 1fr)",
                md: "repeat(2, 1fr)",
                lg: "repeat(3, 1fr)",
              }}
              gap="1.3rem"
            >
              <GridItem height="auto" width={"100%"}> 
                <Center
                  bgColor="#3362AB"
                  height="55px"
                  borderTopLeftRadius="10px"
                  borderTopRightRadius="10px"
                >
                  <Text color="#FFFFFF" fontWeight="700" fontSize="14px">
                    Having Issues on our Portal?
                  </Text>
                </Center>
                <Flex
                  direction="column"
                  bgColor="white"
                  //   height="12rem"
                  paddingX="1.4rem"
                  paddingY="1.2rem"
                  fontSize="14px"
                  borderBottomLeftRadius="10px"
                  borderBottomRightRadius="10px"
                  width={"100%"}
                >
                  <Text>
                    If you are experiencing issues or having challenges on the
                    portal, send us a Help Request; we'll be happy to assist.
                  </Text>
                  <Button
                    justifySelf="center"
                    margin="0 auto"
                    colorScheme="red"
                    marginTop="1.5rem"
                    fontSize="12px"
                    padding={"1rem"}
                    onClick={() => navigate(routes.HelpdeskNewRequest)}
                  >
                    SUBMIT HELP REQUEST
                  </Button>
                </Flex>
              </GridItem>
              <GridItem height="auto" width={"100%"} boxSizing="border-box">
                <Center
                  bgColor="#3362AB"
                  height="55px"
                  borderTopLeftRadius="10px"
                  borderTopRightRadius="10px"
                >
                  <Text color="#FFFFFF" fontWeight="700" fontSize="14px">
                    HelpDesk <br/>Contact Details
                  </Text>
                </Center>
                <Box
                  bgColor="white"
                  //   height="14.5rem"
                  paddingX="1.4rem"
                  paddingY="1.2rem"
                  fontSize="12px"
                  borderBottomLeftRadius="10px"
                  borderBottomRightRadius="10px"
                  width={"100%"}
                >
                  <HStack spacing="1.5rem" mt="0.5rem">
                    <img src={mail} alt="" />
                    <Text wordBreak={"break-word"}>support@naptin.org.ng</Text>
                  </HStack>
                  <HStack spacing="1.5rem" mt="0.5rem">
                    <img src={phone} alt="" />
                    <Text>08060844791, 08033543304, 07067777559</Text>
                  </HStack>
                  <HStack spacing="1.5rem" mt="0.5rem">
                    <img src={img_location} alt="" />
                    <Text>
                      NAPTIN HEADQUARTERS
                      <br />
                      Plot 21, Cadastral Zone,
                      <br />
                      Idu Industrial Area, Mbora
                      <br /> District,Near Wupa Sewage
                      <br />
                      Plant, FCT Abuja, Nigeria
                    </Text>
                  </HStack>
                </Box>
              </GridItem>
              <GridItem height="auto" width={"100%"} boxSizing="border-box">
                <Center
                  bgColor="#3362AB"
                  height="55px"
                  borderTopLeftRadius="10px"
                  borderTopRightRadius="10px"
                >
                  <Text color="#FFFFFF" fontWeight="700" fontSize="14px">
                    Access your Portal
                  </Text>
                </Center>
                <Flex
                  direction="column"
                  bgColor="white"
                  //   height="12rem"
                  paddingX="1.4rem"
                  paddingY="1.2rem"
                  fontSize="14px"
                  borderBottomLeftRadius="10px"
                  borderBottomRightRadius="10px"
                  width={"100%"}
                >
                  <HStack
                    alignContent="center"
                    gap="1rem"
                    mt="2rem"
                    mb="2rem"
                  >
                    <Button
                      justifySelf="center"
                      margin="0 auto"
                      colorScheme="red"
                      paddingX="1rem"
                      fontSize="12px"
                      onClick={() => navigate(routes.Login)}
                    >
                      SIGN IN
                    </Button>
                    <Button
                      justifySelf="center"
                      margin="0 auto"
                      colorScheme="red"
                      paddingX="1rem"
                      fontSize="12px"
                      onClick={() => navigate(routes.PreRegistration)}
                    >
                      REGISTER NOW
                    </Button>
                  </HStack>
                  <Link
                    textAlign="center"
                    color="red"
                    onClick={() => navigate(routes.ForgotPassword)}
                  >
                    Forgot your password?
                  </Link>
                </Flex>
              </GridItem>
              {/* <GridItem width="290px" height="auto">
                <Center
                  bgColor="#3362AB"
                  height="55px"
                  borderTopLeftRadius="10px"
                  borderTopRightRadius="10px"
                >
                  <Text color="#FFFFFF" fontWeight="700" fontSize="14px">
                    Have an Inquiry, Complaint or Suggestion?
                  </Text>
                </Center>
                <Flex
                  direction="column"
                  bgColor="white"
                  height="12rem"
                  paddingX="2.2rem"
                  paddingY="1.2rem"
                  fontSize="14px"
                  borderBottomLeftRadius="10px"
                  borderBottomRightRadius="10px"
                >
                  <Text>
                    Kindly contact us for all your inquiries, comments,
                    complaints or suggestions. We appreciate messages from users
                  </Text>
                  <Button
                    justifySelf="center"
                    margin="0 auto"
                    colorScheme="red"
                    marginTop="1.5rem"
                    fontSize="14px"
                  >
                    CONTACT US
                  </Button>
                </Flex>
              </GridItem> */}

              {/* <GridItem width="320px" height="auto">
                <Center
                  bgColor="#3362AB"
                  height="55px"
                  borderTopLeftRadius="10px"
                  borderTopRightRadius="10px"
                >
                  <Text color="#FFFFFF" fontWeight="700" fontSize="16px">
                    Our HelpDesk Contact Details
                  </Text>
                </Center>
                <VStack
                  spacing="0.3rem"
                  bgColor="white"
                  height="14.5rem"
                  paddingX="2.2rem"
                  paddingY="1.2rem"
                  fontSize="14px"
                  borderBottomLeftRadius="10px"
                  borderBottomRightRadius="10px"
                >
                  <Link
                    textAlign="center"
                    color="red"
                    onClick={() => navigate(routes.PreRegistration)}
                  >
                    Register as a Trainee
                  </Link>
                  <Link
                    textAlign="center"
                    color="red"
                    onClick={() => navigate(routes.UpcomingTraining)}
                  >
                    Upcoming Trainings
                  </Link>
                  <Link
                    textAlign="center"
                    color="red"
                    onClick={() => navigate(courseRoutes.AllCourses)}
                  >
                    Programs & Courses
                  </Link>
                  <Link
                    textAlign="center"
                    color="red"
                    onClick={() => navigate(routes.TrainingCenters)}
                  >
                    Locate a Training Centre
                  </Link>
                  <Link
                    textAlign="center"
                    color="red"
                    onClick={() => navigate(routes.TrackApplication)}
                  >
                    Track your Application
                  </Link>
                  <Link
                    textAlign="center"
                    color="red"
                    onClick={() => navigate(routes.FAQ)}
                  >
                    Frequently Asked Questions
                  </Link>
                  <Link textAlign="center" color="red">
                    Terms of Use
                  </Link>
                </VStack>
              </GridItem> */}
              {/* <GridItem width="290px" height="auto">
                <Center
                  bgColor="#3362AB"
                  height="55px"
                  borderTopLeftRadius="10px"
                  borderTopRightRadius="10px"
                >
                  <Text color="#FFFFFF" fontWeight="700" fontSize="14px">
                    Track Status of your Help Request
                  </Text>
                </Center>
                <Flex
                  direction="column"
                  bgColor="white"
                  height="12rem"
                  paddingX="2.2rem"
                  paddingY="1.2rem"
                  fontSize="14px"
                  borderBottomLeftRadius="10px"
                  borderBottomRightRadius="10px"
                >
                  <Text>
                    You can track and monitor status or progress of your help
                    requests on real-time. click the button below to proceed.
                  </Text>
                  <Button
                    justifySelf="center"
                    margin="0 auto"
                    colorScheme="red"
                    marginTop="1.5rem"
                    fontSize="14px"
                  >
                    TRACK HELP REQUEST
                  </Button>
                </Flex>
              </GridItem> */}
            </Grid>
          </Flex>
        </Flex>
      </Box>
      <Footer />
    </>
  );
};

export default HomeHelpdesk;
